import Button from '@components/DesignLibrary/Button';

type Props = {
  onClick: () => void;
  disabled: boolean;
};

const ActionButton: React.FC<Props> = ({ onClick, children, disabled }) => (
  <Button
    type="button"
    variant="attention"
    size="xs"
    disabled={disabled}
    onClick={onClick}
  >
    {children}
  </Button>
);

export default ActionButton;